import { CountUp } from 'countup.js';

$(() => {
  if ($('.stats, .circle-stats').length) {
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          countStart('.stats')
          observer.unobserve(entry.target);
        }
      });
    }

    const observer = new IntersectionObserver(callback);
    const target = document.querySelector('.stats, .circle-stats');
    observer.observe(target);
  }

  const countStart = () => {
    const counters = document.querySelectorAll('.js-count-up');

    counters.forEach((item) => {
      const value = item.dataset.value;
      const decimalPlaces = item.dataset.decimals || 1;
      const decOptions = {
        decimalPlaces: parseInt(decimalPlaces),
      };

      if(value.indexOf('.') >= 0) {
        // Get the number of decimal places based on the actual value
        const decimalPart = value.split('.')[1];
        const actualDecimals = decimalPart.replace(/0+$/, '').length; // Remove trailing zeros
        const decOptions = {
          decimalPlaces: actualDecimals,
        };
        
        const counter = new CountUp(item, value, decOptions);
        counter.start();
      } else {
        const counter = new CountUp(item, value);
        counter.start();
      }
    });
  };
})
